import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, XIcon } from 'lucide-react';
import { costs } from '../data/problems';
export function CostSection() {
  return <section className="bg-stage blueprint py-16 sm:py-20" aria-labelledby="cost-title" data-id="element-58" data-mp="4l7ye10or1jy">
      <div className="mx-auto max-w-4xl px-4" data-id="element-59" data-mp="4ivaz8c5ryzi">
        <div className="text-center" data-id="element-60" data-mp="3vqhkviph0xot">
          <AlertTriangleIcon className="mx-auto h-9 w-9 text-danger" aria-hidden="true" data-id="element-61" data-mp="3vpes158l8l69" />
          <h2 id="cost-title" className="mt-4 text-3xl font-extrabold text-white sm:text-4xl" data-id="element-62" data-mp="3qtr04i2q1dx2">El costo de no tenerlo</h2>
          <p className="mt-3 text-mutedDark" data-id="element-63" data-mp="3hrq75xeite17">Lo que realmente perdés cada ciclo lectivo sin el Megapack</p>
        </div>

        <div className="mt-10 space-y-2" data-id="element-64" data-mp="3ct6ivqcgfq5o">
          {costs.map(([without, loss], index) => <motion.div key={without} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.28,
          delay: index * 0.03,
          ease: [0.23, 1, 0.32, 1]
        }} className="panel-dark grid gap-2 rounded-lg border-l-4 border-danger p-4 sm:grid-cols-[minmax(0,1fr)_minmax(0,1.6fr)] sm:gap-6" data-id="element-65" data-mp="1g0d1v78n544m" data-mpi={index}>
              <p className="flex items-start gap-2 text-sm font-bold text-white" data-id="element-66" data-mp="fap26kv9h9g5">
                <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-danger" aria-hidden="true" data-id="element-67" data-mp="k9jmjr8vn62d" />
                {without}
              </p>
              <p className="text-sm leading-relaxed text-mutedDark" data-id="element-68" data-mp="17yunp9u532h1">{loss}</p>
            </motion.div>)}
        </div>

        <blockquote className="panel-dark mt-10 rounded-xl border border-steel p-6 text-center text-sm font-semibold leading-relaxed text-onDark sm:p-8" data-id="element-69" data-mp="1cyyvmbgzeovn">
          “La próxima vez que un alumno pregunte para qué sirve estudiar Seguridad e Higiene, podés mostrarle que
          Argentina tiene leyes que protegen a los trabajadores, que existen profesionales dedicados a identificar
          riesgos, que la prevención puede salvar vidas, que cada norma existe porque alguien fue víctima, y que ser un
          prevencionista es ser la primera defensa de la vida en el trabajo. O podés seguir explicando sin ese contexto.”
        </blockquote>
      </div>
    </section>;
}